// src/components/ModalSeleccionFraccionamiento.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FaBuilding, FaCheckCircle, FaArrowRight, FaShieldAlt, FaUserTie, FaHome } from 'react-icons/fa';
import './ModalSeleccionFraccionamiento.css';

const ModalSeleccionFraccionamiento = ({ isOpen, fraccionamientoIds = [], onSelectFraccionamiento, userRol }) => {
    const [fraccionamientosDetails, setFraccionamientosDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedId, setSelectedId] = useState('');

    useEffect(() => {
        let isMounted = true;
        const fetchDetails = async () => {
            if (!isOpen || !Array.isArray(fraccionamientoIds) || fraccionamientoIds.length === 0) {
                setLoading(false);
                return;
            }

            setLoading(true);
            try {
                const promises = fraccionamientoIds.map(async (id) => {
                    try {
                        const snap = await getDoc(doc(db, 'fraccionamientos', id));
                        if (snap.exists()) {
                            const data = snap.data();
                            return {
                                id,
                                nombre: data.nombre || data.condominioNombre || `Fraccionamiento ${id}`,
                                logoUrl: data.configuracionRecibos?.logoUrl || data.logoUrl || null,
                                estado: data.estado || 'Activo',
                            };
                        }
                    } catch (e) {
                        console.warn(`Error al cargar datos del fraccionamiento ${id}`, e);
                    }
                    return { id, nombre: `Fraccionamiento ${id}`, logoUrl: null, estado: 'Activo' };
                });

                const results = await Promise.all(promises);
                if (isMounted) {
                    setFraccionamientosDetails(results);
                    if (results.length > 0) {
                        setSelectedId(results[0].id);
                    }
                    setLoading(false);
                }
            } catch (err) {
                console.error('Error al cargar la lista de fraccionamientos para el modal:', err);
                if (isMounted) setLoading(false);
            }
        };

        fetchDetails();

        return () => { isMounted = false; };
    }, [isOpen, fraccionamientoIds]);

    if (!isOpen) return null;

    const handleConfirm = () => {
        if (selectedId && onSelectFraccionamiento) {
            onSelectFraccionamiento(selectedId);
        }
    };

    const getRoleBadge = () => {
        if (userRol === 'caseta') return { label: 'Caseta de Vigilancia', icon: <FaShieldAlt />, color: '#0284c7' };
        if (['superadmin', 'admin', 'administrator'].includes(userRol)) return { label: 'Administración', icon: <FaUserTie />, color: '#10b981' };
        return { label: 'Residente / Propietario', icon: <FaHome />, color: '#6366f1' };
    };

    const badge = getRoleBadge();

    return (
        <div className="modal-admin-overlay">
            <div className="modal-admin-card">
                <div className="modal-admin-header">
                    <div className="modal-admin-badge-role" style={{ background: badge.color }}>
                        {badge.icon}
                        <span>{badge.label}</span>
                    </div>
                    <h2>Panel de Gestión</h2>
                    <p>Selecciona el fraccionamiento que deseas administrar en este momento:</p>
                </div>

                <div className="modal-admin-body">
                    {loading ? (
                        <div className="modal-admin-skeleton-grid">
                            <div className="skeleton-card"></div>
                            <div className="skeleton-card"></div>
                        </div>
                    ) : (
                        <div className="fraccionamientos-cards-grid">
                            {fraccionamientosDetails.map((item) => {
                                const isSelected = selectedId === item.id;
                                return (
                                    <div
                                        key={item.id}
                                        className={`fracc-card-option ${isSelected ? 'selected' : ''}`}
                                        onClick={() => setSelectedId(item.id)}
                                    >
                                        <div className="fracc-card-icon">
                                            {item.logoUrl ? (
                                                <img src={item.logoUrl} alt={item.nombre} className="fracc-card-logo" />
                                            ) : (
                                                <FaBuilding className="default-icon" />
                                            )}
                                        </div>
                                        <div className="fracc-card-info">
                                            <h3>{item.nombre}</h3>
                                            <span className="fracc-card-status">{item.estado}</span>
                                        </div>
                                        <div className="fracc-card-check">
                                            {isSelected && <FaCheckCircle className="check-icon" />}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="modal-admin-footer">
                    <button
                        type="button"
                        className="btn-confirm-admin-seleccion"
                        disabled={loading || !selectedId}
                        onClick={handleConfirm}
                    >
                        <span>Gestionar este Fraccionamiento</span>
                        <FaArrowRight />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalSeleccionFraccionamiento;
